
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.058 12.395a1 1 0 011.277-.607l7.995 2.842a2 2 0 001.34 0l7.995-2.842a1 1 0 11.67 1.884l-7.995 2.843a4 4 0 01-2.68 0l-7.995-2.843a1 1 0 01-.607-1.277z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.058 16.645a1 1 0 011.277-.607l7.995 2.842a2 2 0 001.34 0l7.995-2.842a1 1 0 11.67 1.884l-7.995 2.843a4 4 0 01-2.68 0l-7.995-2.843a1 1 0 01-.607-1.277z"}}),_c('path',{attrs:{"d":"M13.709 3.307a5 5 0 00-3.418 0L3.243 5.87c-1.756.639-1.756 3.121 0 3.76l7.048 2.563a5 5 0 003.418 0l7.048-2.563c1.756-.639 1.756-3.121 0-3.76L13.71 3.307z"}})])
          )
        }
      }
    